export var PriorityLevelEn;
(function (PriorityLevelEn) {
    PriorityLevelEn[PriorityLevelEn["Low"] = 1] = "Low";
    PriorityLevelEn[PriorityLevelEn["Medium"] = 2] = "Medium";
    PriorityLevelEn[PriorityLevelEn["High"] = 3] = "High";
})(PriorityLevelEn || (PriorityLevelEn = {}));
export const priorityLevel = [
    { value: PriorityLevelEn.Low, label: 'Thấp', color: 'green' },
    { value: PriorityLevelEn.Medium, label: 'Trung bình', color: 'orange' },
    { value: PriorityLevelEn.High, label: 'Cao', color: 'red' }
];
// Tạo Record để lookup nhanh
export const priorityLevelMap = {
    [PriorityLevelEn.Low]: priorityLevel[0],
    [PriorityLevelEn.Medium]: priorityLevel[1],
    [PriorityLevelEn.High]: priorityLevel[2]
};
